import { useRouter } from 'next/router';
// material ui
import { CloseButtonIcon } from './CloseButtonIcon';
// components
import { Button } from 'rsuite';
// utils && hooks
import { useUser } from 'utils/hooks';
import { checkHubspotStatus } from 'utils/pointOfSale/checkHubspotStatus';
import { checkPosIsDisabled } from 'utils/pointOfSale';
// styles
import style from './UploaderButton.module.css';

const UploaderButton = ({ onClickVisibleDragDrop, isOpen, visibleClear, onClickClose, setVisibleClear }) => {
    const { user } = useUser({});
    const {
        pathname,
        query: { posId },
    } = useRouter();
    const gtagClassByPath = pathname === '/[clientId]/efficient-purchase/[posId]' ? '1' : '2';
    const pos = user?.pointsOfSale?.find((pos) => pos?.id === +posId);
    const EX4611 = user?.EX4611;
    const freeTrialFinished = checkHubspotStatus(pos);
    const validation = EX4611 ? checkPosIsDisabled(pos) : freeTrialFinished;

    return (
        <div
            className={`button__upload-file-1 ${style['container-file-system-upload']}`}
            style={{ zIndex: isOpen ? 2100 : 0 }}
        >
            {!visibleClear ? (
                <Button
                    size="sm"
                    onClick={onClickVisibleDragDrop}
                    className={`button__upload-file-${gtagClassByPath} ${style['button-icon-text']}`}
                    startIcon={
                        validation ? (
                            <img
                                src={`/assets/images/upload_cloud_blue_disabled.svg`}
                                className={`${style['upload-icon']}`}
                                width={32}
                                height={32}
                            />
                        ) : (
                            <img
                                src="/assets/images/cloud.svg"
                                className={`button__upload-file-${gtagClassByPath} ${style['upload-icon']}`}
                            />
                        )
                    }
                    disabled={validation}
                />
            ) : (
                <CloseButtonIcon onClickClose={onClickClose} setVisibleClear={setVisibleClear} />
            )}
        </div>
    );
};

export default UploaderButton;
